<template>

    <customdialog v-model="val" :title="$t('Passenger-Search')" maxWidth="700px">

        <!-- Begin Arama Kriterleri ******************************************************************************-->
        <div class="layout">
            <v-text-field v-model="prm.tcKimlikNo" :label="$t('Passenger-Search-Input')"></v-text-field>
            <btnprogres v-model="status.loading" title="Ara" @click="Ara()"></btnprogres>
        </div>
        <!-- End Arama Kriterleri  *******************************************************************************-->

        <!-- Begin Data Table ************************************************************************************-->
        <v-data-table :headers="tableheaders" :items="tabledata" :loading="status.loading" hide-actions
            class="elevation-1">

            <template slot="items" slot-scope="props">
                <tr @click="Sec(props.item)">
                    <td>{{ props.item.adSoyad }}</td>
                    <td>{{ props.item.tcKimlikNo }}</td>
                    <td>{{ props.item.eMail }}</td>
                    <td>{{ props.item.gsm }}</td>
                </tr>
            </template>
        </v-data-table>
        <!-- End Data Table *************************************************************************************** -->
    </customdialog>

</template>


<script>
import tool from '../coper/tools'
import arksnackbar from '@/components/app/coper/comp/arksnackbar.vue'
import btnprogres from '@/components/app/coper/comp/btnprogres.vue'
import customdialog from "@/components/app/coper/comp/customdialog.vue";



export default {
    components: {
        arksnackbar,
        btnprogres,
        customdialog,
    },
    props: {
        kisi: {
            type: Object,
            required: true
        },
        // v-model kullanabilmek için "value" prop'unu eklememiz şart
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // Parent'tan (PassengerCard) gelen değeri yönetmek için köprü
        val: {
            get: function () {
                return this.value;
            },
            set: function (newValue) {
                this.$emit('input', newValue);
            },
        },
    },
    // DİKKAT: İki tane data() vardı, tek data() altında topladık.
    data() {
        return {
            prm: {},
            tableheaders: [
                { text: this.$t('Name'), value: 'adSoyad' },
                { text: this.$t('Identitynumber_label'), value: 'tcKimlikNo' },
                { text: this.$t('Email_label'), value: 'eMail' },
                { text: this.$t('Phonenumber_label'), value: 'gsm' },
            ],
            tabledata: [],
            status: tool.NewSatatus(),
        }
    },
    methods: {
        Ara: Ara,
        Sec: Sec,
    }

}

function Sec(v) {
    this.$emit('updatePassenger',{
        FirstName: v.firstName,
        LastName: v.lastName,
        CitizenNo: v.tcKimlikNo,
        Nationality: v.ulke,
        Email: v.eMail,
        Phone: v.gsm,
        CoperKisiID: v.id,
        PassportNo: v.pasaportNo,
        BirthDate:v.dogumTarihi,
        Gender:v.cinsiyet === "E" ? "Male": "Female",
        PassportExpireDate:v.pasaportBitisTarihi,
        WheelChairService:v.tekerlekliSandalye,
        FrequentFlayerNo:v.mileCard
    });
    this.prm = {};
    this.tabledata = [];
    this.val = false;
}


function Ara() {
    this.tabledata = [];

    if (this.status.loading === false) {
    
        this.status.loading = true;
        setTimeout(() => {
            tool.http_post(this, 'TblAdresMultipleAra', this.prm).then((response) => {
                this.tabledata = response.body;
                this.status.loading = false;
            }, (response) => {
                this.status = tool.responseToStatus(response);
            }).catch(err => {
                this.status.loading = false;
            });
        }, 500);
    }
}
</script>
